/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';
import mbpUtil from 'mbp-api-util';
import calculateCartReducer, { calculateCartWatcherSagas } from './CalculateCart';
import { giftCardWatcherSagas } from './GiftCard';
import { paymenyPlaceOrderWatcherSagas } from './PlaceOrder';
import paymentMethodReducer, { paymentMethodWatcherSagas } from './PaymentMethods';
import orderPlacedPaymentReducer, { orderPlacedPaymentSagas } from './OrderPlacedPayment';
import paymentReadinessReducer from './PaymentReadiness';
import rewardPointsReducer, { rewardPointsWatcherSagas } from './RewardPoints';
import billingAddressReducer, { billingAddressWatcherSagas } from './BillingAddress';
import { promotionWatcherSagas } from './Promotions';

import * as paymentOperation from './Payment-Operations';
import weSaluteReducer from './WeSalute';
import paymentFormReducer from '../../../Checkout/ducks/Payment/ducks/PaymentForm';
import subscriptionReducer from '../../../Checkout/ducks/Payment/ducks/Subscription';
import { watchers as SubscriptionOperations } from '../../../Checkout/ducks/Payment/ducks/Subscription/Subscription-Operations';
import promotionReducer from './Promotions/Promotion-Reducer';

const REACT_APP_INJECTABLE = mbpUtil.getEnv('REACT_APP_INJECTABLE');

let paymentWatcherSagas = [
    ...calculateCartWatcherSagas,
    ...giftCardWatcherSagas,
    ...orderPlacedPaymentSagas,
    ...paymentMethodWatcherSagas,
    ...billingAddressWatcherSagas,
    ...paymentOperation.watchers,
    ...rewardPointsWatcherSagas,
    ...promotionWatcherSagas,
    ...paymenyPlaceOrderWatcherSagas,
];

if (REACT_APP_INJECTABLE === 'false') {
    paymentWatcherSagas = [
        ...calculateCartWatcherSagas,
        ...giftCardWatcherSagas,
        ...orderPlacedPaymentSagas,
        ...paymentMethodWatcherSagas,
        ...billingAddressWatcherSagas,
        ...paymentOperation.watchers,
        ...rewardPointsWatcherSagas,
        ...promotionWatcherSagas,
        ...paymenyPlaceOrderWatcherSagas,
        ...SubscriptionOperations,
    ];
}

const billingAddressPersistConfig = {
    key: 'billingAddress',
    storage: sessionStorage,
};
const billingAddressPersistReducer = persistReducer(billingAddressPersistConfig, billingAddressReducer);

const paymentFormReducerPersistConfig = {
    key: 'paymentForm',
    storage: sessionStorage,
    whitelist: ['paymentMethod'],
};
const paymentFormPersistReducer = persistReducer(paymentFormReducerPersistConfig, paymentFormReducer);

let paymentReducers = combineReducers({
    billingAddress: billingAddressPersistReducer,
    calculateShipping: calculateCartReducer,
    orderPlacedPayment: orderPlacedPaymentReducer,
    paymentMethod: paymentMethodReducer,
    paymentReadiness: paymentReadinessReducer,
    promotion: promotionReducer,
    rewardPoints: rewardPointsReducer,
    weSalute: weSaluteReducer,
});

if (REACT_APP_INJECTABLE === 'false') {
    paymentReducers = combineReducers({
        billingAddress: billingAddressPersistReducer,
        paymentForm: paymentFormPersistReducer,
        promotion: promotionReducer,
        calculateShipping: calculateCartReducer,
        orderPlacedPayment: orderPlacedPaymentReducer,
        paymentMethod: paymentMethodReducer,
        paymentReadiness: paymentReadinessReducer,
        rewardPoints: rewardPointsReducer,
        weSalute: weSaluteReducer,
        subscription: subscriptionReducer,
    });
}

export {
    paymentWatcherSagas,
};

export default paymentReducers;
